import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import dropdownInitial from "../../assets/dropdownInitial.svg";
import dropdownExpanded from "../../assets/dropdownExpanded.svg";

import { flatMap, map, property } from "lodash";
import { RefreshIcon } from "@heroicons/react/outline";
import BiButton from "../primitives/buttons/BiButton.primitive";

interface ModuleCardProps {
  label: string;
  children?: React.ReactNode;
  index: number;
}

const collapsibleCss = "collapsed transition focus:outline-none";

const CollapsibleCard = ({ children, label, index }: ModuleCardProps) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState<boolean>(index === 0 ? true : false);

  const collapsibleFunction = async () => {
    setExpanded(!expanded);
  };
  return (
    <div className={`mb-4 flex flex-col rounded-md border-[1px]`}>
      <button
        type="button"
        className={`flex h-14 w-full cursor-pointer flex-row items-center justify-between ${
          !expanded && "rounded-md"
        } px-4`}
        style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }}
        onClick={collapsibleFunction}
      >
        <div className={`flex w-full flex-row justify-between`}>
          <div className="text-start font-semibold">{t(label)}</div>

          <img src={expanded ? dropdownExpanded : dropdownInitial}></img>
        </div>
      </button>
      <div
        className={`accordion-collapse rounded-b-lg ${collapsibleCss} ${
          expanded ? "show" : "hidden"
        }`}
        aria-expanded={expanded}
        style={{
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
        }}
      >
        <div className="flex flex-col p-4">{children}</div>
      </div>
    </div>
  );
};

export default CollapsibleCard;
